module.exports = __webpack_public_path__ + "assets/img/25_319.51915111.jpg";